const MOBILE_KEYWORDS = ['android', 'webos', 'iphone', 'ipad', 'blackberry', 'windows phone'] as const;

/**
 * Минимальное количество одновременных точек касания для определения устройства как мобильного.
 */
const MIN_TOUCH_POINTS = 1;

/**
 * Определяет, является ли устройство мобильным (телефон или планшет).
 */
export function isMobileDevice(): boolean {
    if ('userAgentData' in navigator && navigator.userAgentData) {
        const userAgentData = navigator.userAgentData as { mobile: boolean };

        return userAgentData.mobile;
    }

    const hasTouchScreen = navigator.maxTouchPoints >= MIN_TOUCH_POINTS;

    if (hasTouchScreen) {
        return true;
    }

    const userAgent = navigator.userAgent.toLowerCase();

    return MOBILE_KEYWORDS.some(keyword => userAgent.includes(keyword));
}
